.container {
  -webkit-user-select: text;
          user-select: text;
}
